var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/solid';
import { Link } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function Breadcrumb(props) {
    var route = useRoute(Ziggy);
    var pages = [];
    var className = props.className, team = props.team, branch = props.branch, client = props.client, current = props.current, certificate = props.certificate, tab = props.tab, pets10Form = props.pets10Form, clientForm = props.clientForm, calendar = props.calendar, site = props.site;
    if (team) {
        pages.push({ name: team.name, href: route('dashboard'), current: false });
    }
    if (branch) {
        pages.push({ name: branch.name, href: route('team.branch.certificate.index', { team: team.id, branch: branch.id }), current: false });
        // pages.push({name: branch.name, href: route('team.branch.show', {team: team.id, branch: branch.id}), current: false});
    }
    if (tab == "clients") {
        pages.push({ name: "Clients", href: route('team.branch.client.index', { team: team.id, branch: branch.id }), current: false });
    }
    if (tab == "vets") {
        pages.push({ name: "Vets", href: route('team.branch.vet.index', { team: team.id, branch: branch.id }), current: false });
    }
    // if (tab == "certificate-numbers") {
    //     pages.push({name: "Vets", href: route('team.branch.certificate-number.index', {team: team.id, branch: branch.id}), current: false});
    // }
    if (client) {
        pages.push({ name: client.name, href: route('team.branch.client.show', { team: team.id, branch: branch.id, client: client.id }), current: false });
    }
    if (certificate) {
        pages.push({ name: 'Certificate', href: route('team.branch.certificate.client-step', { team: team.id, branch: branch.id, certificate: certificate.id }), current: false });
    }
    if (clientForm) {
        pages.push({ name: 'Schedule', href: route('team.branch.client-form.index', { team: team.id, branch: branch.id }), current: false });
        pages.push({ name: clientForm.client.name, href: null, current: true });
    }
    if (calendar) {
        pages.push({ name: 'Calendars', href: route('team.calendar.index', { team: team.id }), current: false });
        pages.push({ name: calendar.name || "Create", href: null, current: true });
    }
    if (site) {
        pages.push({ name: 'Calendars', href: route('team.calendar.index', { team: team.id }), current: false });
        pages.push({ name: site.name, href: null, current: true });
    }
    if (pets10Form) {
        pages.push({ name: 'Certificate numbers', href: route('team.branch.certificate-number.index', { team: team.id, branch: branch.id }), current: false });
    }
    return (_jsx("nav", __assign({ className: "flex ".concat(className), "aria-label": "Breadcrumb" }, { children: _jsxs("ol", __assign({ role: "list", className: "flex flex-wrap lg:items-center space-x-4" }, { children: [_jsx("li", { children: _jsx("div", { children: _jsxs(Link, __assign({ href: route('dashboard'), className: "text-sky-100 hover:text-sky-200" }, { children: [_jsx(HomeIcon, { className: "flex-shrink-0 h-5 w-5", "aria-hidden": "true" }), _jsx("span", __assign({ className: "sr-only" }, { children: "Home" }))] })) }) }), pages.map(function (page, i) { return (page.current == false ? _jsx("li", { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(ChevronRightIcon, { className: "flex-shrink-0 h-5 w-5 text-sky-200", "aria-hidden": "true" }), _jsx(Link, __assign({ href: page.href, className: "ml-4 text-sm font-medium text-white hover:text-sky-200 border-b border-sky-200", "aria-current": page.current ? 'page' : undefined }, { children: page.name }))] })) }, i) : _jsx("li", { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(ChevronRightIcon, { className: "flex-shrink-0 h-5 w-5 text-sky-200", "aria-hidden": "true" }), _jsx("span", __assign({ className: "ml-4 text-sm font-medium text-white" }, { children: page.name }))] })) }, i)); }), current && _jsx("li", { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx(ChevronRightIcon, { className: "flex-shrink-0 h-5 w-5 text-sky-200", "aria-hidden": "true" }), _jsx("span", __assign({ className: "ml-4 text-sm font-medium text-white" }, { children: current }))] })) })] })) })));
}
